var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1707 1707",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_569517840"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1279 1609l-1079 0c-14,0 -25,-11 -25,-25l0 -1355c0,-14 11,-25 25,-25l825 0c14,0 25,11 25,25 0,14 -11,25 -25,25l-802 0 0 1308 1032 0 0 -190c0,-14 11,-25 25,-25 14,0 25,11 25,25l0 214c-2,12 -13,23 -26,23zm0 -806c-14,0 -25,-11 -25,-25l0 -294c0,-13 11,-24 25,-24 13,0 24,11 24,24l0 296c0,12 -11,23 -24,23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1279 508l-254 0c-14,0 -25,-11 -25,-25l0 -254c0,-9 5,-18 15,-22 10,-4 19,-1 26,6l256 255c6,7 9,18 5,26 -4,9 -12,14 -23,14zm-231 -48l172 0 -172 -172 0 172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M200 1365l-175 0c-14,0 -25,-11 -25,-25l0 -1284c0,-14 11,-25 25,-25l911 0c14,0 25,11 25,25l0 173c0,14 -11,25 -25,25 -14,0 -25,-11 -25,-25l0 -149 -861 0 0 1235 150 0c14,0 25,11 25,25 0,14 -13,25 -25,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M991 1323c-97,0 -188,-37 -257,-106 -70,-70 -107,-161 -107,-258 0,-97 37,-189 107,-258 141,-142 373,-142 514,0 143,143 143,374 0,516 -68,69 -159,106 -257,106zm0 -679c-80,0 -160,30 -223,91 -123,124 -123,324 0,447 60,60 139,93 223,93 85,0 164,-33 224,-93 123,-123 123,-323 0,-447 -63,-61 -143,-91 -224,-91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1574 1676c-17,0 -32,-7 -43,-18l-273 -274c-11,-11 -18,-26 -18,-43 0,-16 7,-31 18,-43l73 -73c24,-24 63,-24 85,0l273 273c24,24 24,63 0,85l-74 73c-9,14 -24,20 -41,20zm-200 -419c-3,0 -5,1 -8,3l-74 73c-4,4 -4,13 0,17l274 273c4,4 12,4 16,0l74 -74c4,-4 4,-12 0,-16l-273 -273c-3,-2 -6,-3 -9,-3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1312 1304c-6,0 -13,-3 -17,-7l-80 -80c-10,-10 -10,-25 0,-35 9,-10 25,-10 34,0l81 80c10,10 10,25 0,35 -7,4 -13,7 -18,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1023 1445l-676 0c-14,0 -25,-11 -25,-25 0,-13 11,-24 25,-24l676 0c14,0 25,11 25,24 0,14 -11,25 -25,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M574 1261l-227 0c-14,0 -25,-11 -25,-25 0,-14 11,-25 25,-25l226 0c14,0 25,11 25,25 0,14 -11,25 -24,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M574 1077l-227 0c-14,0 -25,-12 -25,-25 0,-14 11,-25 25,-25l226 0c14,0 25,11 25,25 0,13 -11,25 -24,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M574 892l-227 0c-14,0 -25,-11 -25,-25 0,-14 11,-25 25,-25l226 0c14,0 25,11 25,25 0,14 -11,25 -24,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M574 706l-227 0c-14,0 -25,-11 -25,-25 0,-13 11,-25 25,-25l226 0c14,0 25,12 25,25 0,14 -11,25 -24,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M892 519l-545 0c-14,0 -25,-11 -25,-25 0,-14 11,-25 25,-25l545 0c14,0 25,11 25,25 0,14 -11,25 -25,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M874 1114c-3,0 -6,0 -7,-1l-3 0c-3,0 -6,0 -8,-2 -3,0 -5,-1 -7,-3 -3,-1 -6,-2 -7,-4 0,0 0,0 0,0 0,0 -2,0 -2,-1 -2,-1 -4,-3 -7,-4 -1,-2 -2,-2 -4,-3l-1 -1c0,0 0,0 0,0 0,0 0,0 0,0l-6 -3c-1,-2 -2,-3 -4,-4 -3,-3 -4,-6 -5,-9l-66 -113c-18,-32 -7,-71 24,-90 0,0 0,0 1,0 32,-19 72,-6 91,24l34 60 250 -144c30,-18 71,-8 90,23 18,32 7,73 -25,91l-306 174c-3,2 -5,3 -7,4 -2,2 -5,2 -6,3 -1,0 -1,2 -3,2 -3,1 -5,1 -9,1l-2 0c-1,0 -4,0 -5,0zm-6 -50l0 0c1,0 3,0 3,0 1,0 1,0 3,0l1 0c0,0 0,0 1,0 2,0 2,0 3,-1 2,0 2,-2 3,-2 0,0 1,0 3,-1l302 -175c8,-5 11,-15 7,-23 -4,-9 -15,-11 -24,-6l-271 157c-12,7 -27,3 -34,-9l-47 -80c-4,-8 -15,-11 -23,-7 -9,6 -12,15 -6,24l68 116c1,2 1,2 3,3 0,0 0,0 1,1 2,0 2,2 3,3 0,0 1,0 1,1 2,0 2,2 3,2 -1,-3 0,-3 0,-3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.d94c1e6eff2c6a4941c0c6aeda096d1e.svg";
export { ForwardRef as ReactComponent };